export enum Paths {
  Search = 'search/',
}
